export class PaymentResponse {
    ejecucionExitosa: boolean;
    eventualMensajeError: string
}